import React, { memo } from "react";
import Button from "@mui/material/Button";

export const UiButton = memo((props) => {
  const {
    variant,
    name,
    size,
    onClick,
    fullWidth,
    color,
    disabled,
    className,
    loading,
    type,
  } = props;

  const btnClassName =
    `${className || ""} ${loading ? "df-setting-loader" : ""}`.trim();

  return (
    <>
      <Button
        variant={variant}
        onClick={onClick}
        fullWidth={fullWidth}
        color={color}
        disabled={disabled}
        className={btnClassName}
        size={size}
        loading={loading}
        type={type || "button"}
      >
        {!loading ? name : ""}
      </Button>
    </>
  );
});

export const UiGradiantOutlinedBtn = memo((props) => {
  const {
    variant,
    name,
    size,
    onClick,
    fullWidth,
    color,
    disabled,
    className,
    type,
  } = props;

  const gradiantClass = `df-grad-outline ${props.disableWrapper || ""}`.trim();

  return (
    <>
      <div className={gradiantClass}>
        <Button
          variant={variant}
          onClick={onClick}
          fullWidth={fullWidth}
          color={color}
          disabled={disabled}
          className={className}
          size={size}
          type={type || "button"}
        >
          {name}
        </Button>
      </div>
    </>
  );
});

export const UiIconButton = memo((props) => {
  const {
    variant,
    name,
    size,
    onClick,
    fullWidth,
    color,
    disabled,
    className,
    icon,
  } = props;
  return (
    <>
      <Button
        variant={variant}
        onClick={onClick}
        fullWidth={fullWidth}
        color={color}
        disabled={disabled}
        className={className}
        size={size}
      >
        {icon}
        {name}
      </Button>
    </>
  );
});

export const UiTextIconButton = memo((props) => {
  const {
    variant,
    name,
    size,
    onClick,
    fullWidth,
    color,
    disabled,
    className,
    icon,
    type,
  } = props;
  return (
    <>
      <Button
        variant={variant}
        onClick={onClick}
        fullWidth={fullWidth}
        color={color}
        disabled={disabled}
        className={className}
        size={size}
        type={type || "button"}
      >
        {props?.beforeIcon ? (
          <>
            <span className="df-before-icon">{icon}</span> {name}
          </>
        ) : (
          <>
            {name} <span>{icon}</span>
          </>
        )}
      </Button>
    </>
  );
});
